<!--
 * @Author: yzf
 * @Date: 2020-12-01 16:27:20
 * @LastEditTime: 2020-12-03 14:00:35
 * @LastEditors: yzf
 * @Description: 这是文件
 * @FilePath: /alex/Volumes/project/hex/wuwei/src/views/other/changeLog/insert.vue
 * @大威天龙,世尊地藏,般若诸佛,般若巴麻空,没有bug
-->
<template>
  <div id="insert-change-log">
    <div class="head">
      新增更新日志
    </div>
    <div class="content">
      <div class="date">
        <div class="text">
          日期:
        </div>
        {{finalDate}}
      </div>
      <div class="version">
        <div class="text">
          更新状态:
        </div>
        <a-radio-group v-model="type" size="large">
          <a-radio-button v-for='item in types' :value="item.value" :key="item.value">
            {{item.text}}
          </a-radio-button>
        </a-radio-group>
      </div>
      <div class="logs">
        <div class="text">
          日志:
        </div>
        <div class="right">
          <div class="log" v-for="(log, idx) in content" :key='idx'>
            <span>
              {{idx+1}}:
            </span>
            <a-input v-model='content[idx]'/>
          </div>
          <div class="log">
            <span>
              {{content.length+1}}:
            </span>
            <a-input v-model='text' @keydown.enter='enter' placeholder='输入后请按回车输入下一个'/>
          </div>
        </div>
      </div>
    </div>
    <div class="sure">
      <a-popconfirm
        title="发布后不可修改,确认发布?"
        ok-text="确定"
        cancel-text="取消"
        @confirm="sure"
      >
        <a-button>发布</a-button>
      </a-popconfirm>
    </div>
  </div>
</template>

<script>
export default {
  name: 'insert-change-log',
  data () {
    return {
      content: [],
      date: null,
      type: '3',
      timer: null,
      text: '',
      types: [{
        text: '修补',
        value: '3'
      }, {
        text: '更新',
        value: '2'
      }, {
        text: '迭代',
        value: '1'
      }]
    }
  },
  computed: {
    finalDate () {
      if (!this.date) {
        return ''
      }
      return new Date(this.date).toLocaleString()
    }
  },
  methods: {
    enter () {
      this.content.push(this.text)
      this.text = ''
    },
    sure () {
      if (this.text) {
        this.enter()
      }
      const content = this.content.filter(item => item)
      if (!content.length) {
        this.$message.warning('禁止更新空内容')
        return
      }
      const data = {
        date: this.date,
        type: this.type,
        content
      }
      this.$post('/wuwei/api/logs/log', data).then(res => {
        if (res.info === '200') {
          this.$message.success('添加成功')
          this.reset()
        } else {
          this.$message.error('添加失败,请检查权限和网络')
        }
      })
    },
    reset () {
      this.content = []
      this.type = '3'
      this.text = ''
    }
  },
  mounted () {
    this.date = new Date().getTime()
    this.timer = setInterval(() => {
      this.date = new Date().getTime()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="less" scoped>
#insert-change-log {
  display: flex;
  background: #fff;
  padding: 20px;
  font-size: 16px;
  width: 800px;
  margin: 20px auto;
  flex-direction: column;
  height: 100px;
  flex-grow: 1;
  .head {
    font-size: 24px;
    flex-shrink: 0;
  }
  .content {
    flex-grow: 1;
    height: 100px;
    display: flex;
    flex-direction: column;
    &>div {
      display: flex;
      align-items: center;
      margin-top: 12px;
      flex-shrink: 0;
      .text {
        width: 100px;
        text-align: right;
        flex-shrink: 0;
        margin-right: 12px;
      }
    }
    .logs {
      height: 100px;
      flex-grow: 1;
      align-items: flex-start;
      .right {
        flex-grow: 1;
        overflow: auto;
        height: 100%;
        .log {
          margin-top: 8px;
          display: flex;
          align-items: center;
          span {
            min-width: 20px;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .sure {
    text-align: center;
    margin: 24px;
  }
}
</style>
